import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, CircularProgress } from '@mui/material';
import { Button } from 'components/index';

interface GenericCopyReportDialogProps {
  open: boolean;
  onClose: () => void;
  defaultReportName: string;
  handleCreateCopy: (reportName: string) => Promise<void>;
}

const GenericCopyReportDialog: React.FC<GenericCopyReportDialogProps> = ({ open, onClose, defaultReportName, handleCreateCopy }) => {
  const [reportName, setReportName] = useState(defaultReportName);
  const [isLoading, setIsLoading] = useState(false);

  const handleCreate = async () => {
    try {
      setIsLoading(true);
      await handleCreateCopy(reportName);
      onClose();
    } catch (error) {
      // Error handling is expected to be in `handleCreateCopy`
    } finally {
      setIsLoading(false);
    }
  };

  const handleDialogClose = () => {
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleDialogClose} maxWidth='sm' fullWidth>
      <DialogTitle>Duplicate Report</DialogTitle>
      <DialogContent>
        <div style={{ marginTop: '16px' }}>
          <TextField label='Report Name' value={reportName} onChange={e => setReportName(e.target.value)} fullWidth />
        </div>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'flex-end' }}>
        <Button variant='outlined' onClick={handleDialogClose} color='secondary' disabled={isLoading}>
          Cancel
        </Button>
        <Button
          variant='contained'
          onClick={handleCreate}
          disabled={!reportName.trim()}
          startIcon={isLoading && <CircularProgress size={24} color='inherit' />}
          color='primary'
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default React.memo(GenericCopyReportDialog);
